import { Box, InputBase, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { postUserSignUpFinal } from "../../api/signin";
import { changeGroupCodeUser, updateInfo } from "../../api/user";
import BloodType from "../../assets/SVG/bloodType";
import DescriptionIcon from "../../assets/SVG/descriptionIcon";
import EyeClosedIcon from "../../assets/SVG/eyeClosedIcon";
import EyeOpenIcon from "../../assets/SVG/eyeOpenIcon";
import LockIcon from "../../assets/SVG/lockIcon";
import PhoneIcon2 from "../../assets/SVG/phoneIcon2";
import ProfileIcon from "../../assets/SVG/profileIcon";
import Vector from "../../assets/SVG/vector";
import InputLoginForm from "../login/inputLoginForm";
import { useNavigate } from "react-router-dom";

export default function SigninFormMujahid3({
  setLevel,
  dataForm,
  setDataForm,
  update,
}) {
  const navigate = useNavigate();
  const styleLabel = {
    color: "#2B2B2B",
    textAlign: "right",
    fontSize: "16px",
    fontWeight: "600",
  };
  const [showPassword, setShowPassword] = useState();
  const [showPassword1, setShowPassword1] = useState();
  const [updateGroupCode, setUpdateGroupCode] = useState();
  // const [codeGroup, setCodeGroup] = useState();
  // useEffect(() => {
  //   if (codeGroup !== 0)
  //     setDataForm({ ...dataForm, groupCode: Number(codeGroup) });
  // }, [codeGroup]);
  // console.log(updateGroupCode);
  return (
    <Box mt="20px" width="380px">
      <Typography mt="10px" sx={styleLabel} display="flex">
        {"نام و نسبت فرد مذکور"}
        <Typography color="red" mr="5px">
          *
        </Typography>
      </Typography>
      <Box display="flex" gap="5px">
        <Box
          sx={{
            border: "solid 1px var(--emr-borderInput)",
            borderRadius: "8px",
            px: "10px",
            width: "60%",
            height: "50px",
            display: "flex",
            mt: "5px",
            boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <ProfileIcon />
          <InputBase
            value={dataForm.nearbyName}
            onChange={(e) =>
              setDataForm({ ...dataForm, nearbyName: e.target.value })
            }
            placeholder="نام کامل را وارد نمائید."
          />
        </Box>
        <Box
          sx={{
            border: "solid 1px var(--emr-borderInput)",
            borderRadius: "8px",
            px: "10px",
            width: "40%",
            height: "50px",
            display: "flex",
            mt: "5px",
            boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <ProfileIcon />
          <InputBase
            value={dataForm.nearbyRel}
            onChange={(e) =>
              setDataForm({ ...dataForm, nearbyRel: e.target.value })
            }
            placeholder="نسبت شخص."
          />
        </Box>
      </Box>
      <Typography mt="10px" sx={styleLabel} display="flex">
        {"تلفن همراه فرد مذکور"}
        <Typography color="red" mr="5px">
          *
        </Typography>
      </Typography>
      <Box
        sx={{
          border: "solid 1px var(--emr-borderInput)",
          borderRadius: "8px",
          px: "10px",
          height: "50px",
          display: "flex",
          mt: "5px",
          boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <PhoneIcon2 />
        <InputBase
          inputProps={{ maxLength: 11 }}
          value={dataForm.nearbyPhone}
          onChange={(e) =>
            setDataForm({
              ...dataForm,
              nearbyPhone: e.target.value.replace(/\D/g, ""),
            })
          }
          sx={{
            "&.MuiInputBase-root ": {
              width: "75% !important",
            },
          }}
          placeholder="شماره تلفن همراه خود را وارد نمائید."
        />
      </Box>
      {!update && (
        <>
          <Typography mt="10px" sx={styleLabel} display="flex">
            {"رمز عبور"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <Box
            sx={{
              border: "solid 1px var(--emr-borderInput)",
              borderRadius: "8px",
              px: "10px",
              height: "50px",
              display: "flex",
              mt: "5px",
              boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <LockIcon />
            <InputBase
              sx={{ width: "80%" }}
              type={!showPassword ? "password" : "text"}
              value={dataForm.password}
              onChange={(e) =>
                setDataForm({ ...dataForm, password: e.target.value })
              }
              placeholder="رمز عبور خود را وارد کنید."
            />
            {dataForm.password && (
              <Box
                sx={{ cursor: "pointer", mt: "5px" }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {!showPassword ? <EyeOpenIcon /> : <EyeClosedIcon />}
              </Box>
            )}
          </Box>
          {/* <InputLoginForm
      password
      width='330px'
      value={dataForm.password}
      onChange={(e) =>
        setDataForm({ ...dataForm, password: e.target.value })
          } placeholder="رمز عبور خود را وارد کنید." >
          <LockIcon />
        </InputLoginForm> */}
          <Typography mt="10px" sx={styleLabel} display="flex">
            {"تکرار رمز عبور"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <Box
            sx={{
              border: "solid 1px var(--emr-borderInput)",
              borderRadius: "8px",
              px: "10px",
              height: "50px",
              display: "flex",
              mt: "5px",
              boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <LockIcon />
            <InputBase
              sx={{ width: "80%" }}
              type={!showPassword1 ? "password" : "text"}
              value={dataForm.passwordRepeat}
              onChange={(e) =>
                setDataForm({ ...dataForm, passwordRepeat: e.target.value })
              }
              placeholder="رمز عبور خود را وارد کنید."
            />
            {dataForm.passwordRepeat && (
              <Box
                sx={{ cursor: "pointer", mt: "5px" }}
                onClick={() => setShowPassword1(!showPassword1)}
              >
                {!showPassword1 ? <EyeOpenIcon /> : <EyeClosedIcon />}
              </Box>
            )}
          </Box>
        </>
      )}
      <Typography width="100%" color="var(--emr-disable)" fontSize="16px">
        {
          "در صورت داشتن کد معرف از طرف گروهی، فرم زیر را تکمیل کنید. در غیر این صورت، قسمت زیر را نادیده بگیرید."
        }
      </Typography>
      <Typography mt="10px" sx={styleLabel}>
        {"کد معرف"}
      </Typography>
      <Box
        sx={{
          border: "solid 1px var(--emr-borderInput)",
          borderRadius: "8px",
          px: "10px",
          height: "50px",
          display: "flex",
          mt: "5px",
          boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <DescriptionIcon />
        <InputBase
          inputProps={{ maxLength: 6 }}
          value={dataForm.groupCode}
          onChange={(e) => {
            if (update) {
              setUpdateGroupCode(e.target.value.replace(/\D/g, ""));
              setDataForm({
                ...dataForm,
                groupCode: e.target.value.replace(/\D/g, ""),
              });
            } else {
              setDataForm({
                ...dataForm,
                groupCode: e.target.value.replace(/\D/g, ""),
              });
            }
          }}
          placeholder="کد معرف گروه را وارد نمائید."
        />
      </Box>
      <Box display="flex" justifyContent="end">
        <button
          style={{
            border: "none",
            width: "150px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "white",
            // boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            padding: "12px 0px",
            marginTop: "20px",
            borderRadius: "8px",
          }}
          onClick={() => {
            setLevel(2);
          }}
        >
          <Box sx={{ transform: "rotate(180deg)", mt: "-4px" }}>
            <Vector color="#E24B4B" />
          </Box>
          <Typography
            fontWeight={"bold"}
            fontSize="16px"
            color="#E24B4B"
            mr="10px"
          >
            مرحله قبل
          </Typography>
        </button>
        <button
          style={{
            border: "none",
            width: "150px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#6CBBC7",
            boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            padding: "12px 0px",
            marginTop: "20px",
            borderRadius: "8px",
          }}
          onClick={() => {
            if (update) {
              if (update && updateGroupCode) {
                changeGroupCodeUser(updateGroupCode)
                  .then((x) => {})
                  .catch(() => {});
              }
              if (dataForm.nearbyRel === "" || !dataForm.nearbyRel) {
                toast.error("فیلد های ضروری پر شوند");
              } else {
                updateInfo(dataForm)
                  .then(() => {
                    navigate("/");
                  })
                  .catch(() => {});
              }
            } else {
              if (
                dataForm.phone !== "" &&
                // dataForm.abilities !== "" &&
                // dataForm.diseases !== "" &&
                // dataForm.allergies !== "" &&
                // dataForm.bloodType !== "" &&
                dataForm.nearbyName !== "" &&
                dataForm.nearbyPhone !== "" &&
                // dataForm.nearbyRel !== "" &&
                dataForm.password !== "" &&
                dataForm.passwordRepeat !== ""
              ) {
                if (dataForm.nearbyRel === "" || !dataForm.nearbyRel) {
                  toast.error("فیلد های ضروری پر شوند");
                } else {
                  if (dataForm.password !== dataForm.passwordRepeat) {
                    toast.error("رمز عبور و تکرار ان یکسان نیست");
                  } else {
                    postUserSignUpFinal(dataForm)
                      .then(() => {
                        setLevel(4);
                      })
                      .catch((err) => {
                        // toast.error(err.data)
                      });
                  }
                }
              } else {
                toast.error("فیلد های ضروری پر شوند");
              }
            }
          }}
        >
          <Typography fontSize="16px" color="white" ml="10px">
            مرحله بعد
          </Typography>
          <Vector color="white" />
        </button>
      </Box>
    </Box>
  );
}
